import {Component, OnInit, ViewChild} from '@angular/core';
import {MatSort} from '@angular/material/sort';
import {MatDialog} from '@angular/material/dialog';
import {MatTableDataSource} from '@angular/material/table';
import {SnackBarIconService} from '../shared/snack-bar-icon/snack-bar-icon.service';
import {CountriesDialogComponent} from './dialogs/countries-dialog/countries-dialog.component';
import {Subscription} from 'rxjs';
import {ConfirmComponent} from '../shared/dialogs/confirm/confirm.component'
import {ContriesService} from '../services/countries.service';
import {FormGroup} from '@angular/forms';

@Component({
  selector: 'app-countries',
  templateUrl: './countries.component.html',
  styleUrls: [ './countries.component.scss' ],
  entryComponents: [
    CountriesDialogComponent
  ]
})
export class CountriesComponent implements OnInit {

  private sub: Subscription;
  public dataSource = new MatTableDataSource<any>([]);
  public displayedColumns: string[] = [ 'icon', 'country', 'edit', 'delete' ];

  constructor (
    private _countriesService: ContriesService,
    private _snackBar: SnackBarIconService,
    private _dialog: MatDialog,
  ) { }

  // @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  ngOnInit () {
    this.loadCountries();
  }

  ngOnDestroy () {
    if (this.sub)
      this.sub.unsubscribe();
  }

  loadCountries () {
    this.sub = this._countriesService.select().subscribe({
      next: countries => {
        this.dataSource.data = countries;
        this.dataSource.sort = this.sort;
      },
      error: err => console.log("erro ao ler countries: " + err.message)
    });
  }

  applyFilter (filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  openDialog (entity) {

    let data = {'id': '0'};
    if (entity) {
      data = entity;
    }

    let dialogRef = this._dialog.open(CountriesDialogComponent, {
      width: '460px',
      height: '400px',
      panelClass: 'custom-dialog-container',
      data: data
    });

    dialogRef.afterClosed().subscribe(result => {

      if (!result) {
        return;
      }

      const actionType: string = result[ 0 ];
      const form: FormGroup = result[ 1 ];
      const image: any = result[ 2 ];
      var formData: any = form.getRawValue();
      formData.file = image.name;

      if (actionType == 'insert') {
        console.log("insert: " + JSON.stringify(formData));
        console.log("image: " + JSON.stringify(image.name));

        this._countriesService.insert(formData)
          .then((result) => {
            if (image) {
              this._countriesService.uploadImage(image, result.id)
            }
            this._snackBar.openSnackBar("Sucesso!", '', 'success')
          })
          .catch(() => {
            console.log("insert country error")
          })

      } else if (actionType == 'update') {
        /*
        this._countriesService.update(entity)
          .then(() => {
            // console.log(entity.id);
            if (image) {
              this._countriesService.uploadImage(image, entity.id)
            }
            this._snackBar.openSnackBar("Sucesso!", '', 'success')
          })
          .catch(() => {
            console.log("update countries error")
          })
            */
      }

    })

  }





  delete (element) {
    let dialogRef = this._dialog.open(ConfirmComponent, {
      width: '350px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: {title: "Confirme", message: element.country + "<br><br>Excluir este pais?"}
    });
    dialogRef.afterClosed().subscribe(result => {

      if (result == "ok") {

        this._countriesService.deleteFileInStorage(element.image)
          .then(() => {

            this._countriesService.delete(element.id)
              .then(
                () => {
                  this._snackBar.openSnackBar("Sucesso!", '', 'success')
                }
              )
              .catch(
                (error) => {console.log("delete papel error: " + error.message)}
              )

          })

      }
    })
  }

}
